"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const permissionType_1 = require("../../../contracts/generated/Enum/permissionType");
const typescriptHacks_1 = require("../../../helper/typescriptHacks");
const apiPath = endpoints_1.endpoints.permission;
const permissionController = (service) => ({
    readCurrentUsersPermissions: () => {
        return service.get(apiPath, service.addAccessTokenToHeaders);
    },
    readPermissionsForUserGuid: (userGuid) => {
        return service.get(`${apiPath}/${userGuid}`);
    },
    addForUser: (userGuid, permissionType) => {
        return service.post(`${apiPath}/${userGuid}/${permissionType_1.PermissionType[permissionType].toString()}`, typescriptHacks_1.anyObject, service.addAccessTokenToHeaders);
    },
    delPermissionForUser: (userGuid, permissionType) => {
        const url = `${apiPath}/${userGuid}/${permissionType_1.PermissionType[permissionType].toString()}`;
        return service.delete(url, service.addAccessTokenToHeaders);
    }
});
exports.permissionController = permissionController;
